__turbopack_context__.v({
  "areaText": "PlotDetailCard-module__iScONa__areaText",
  "card": "PlotDetailCard-module__iScONa__card",
  "emptyText": "PlotDetailCard-module__iScONa__emptyText",
  "expandBtn": "PlotDetailCard-module__iScONa__expandBtn",
  "expandBtnLg": "PlotDetailCard-module__iScONa__expandBtnLg",
  "expandBtnOff": "PlotDetailCard-module__iScONa__expandBtnOff",
  "expandBtnOn": "PlotDetailCard-module__iScONa__expandBtnOn",
  "expandBtnSm": "PlotDetailCard-module__iScONa__expandBtnSm",
  "expandIconLg": "PlotDetailCard-module__iScONa__expandIconLg",
  "expandIconSm": "PlotDetailCard-module__iScONa__expandIconSm",
  "header": "PlotDetailCard-module__iScONa__header",
  "headerLabel": "PlotDetailCard-module__iScONa__headerLabel",
  "noteBox": "PlotDetailCard-module__iScONa__noteBox",
  "notesBox": "PlotDetailCard-module__iScONa__notesBox",
  "notesBoxIcon": "PlotDetailCard-module__iScONa__notesBoxIcon",
  "notesBoxLabel": "PlotDetailCard-module__iScONa__notesBoxLabel",
  "paramSource": "PlotDetailCard-module__iScONa__paramSource",
  "paramsSection": "PlotDetailCard-module__iScONa__paramsSection",
  "strongDark": "PlotDetailCard-module__iScONa__strongDark",
  "wrapper": "PlotDetailCard-module__iScONa__wrapper",
  "yearBox": "PlotDetailCard-module__iScONa__yearBox",
  "yearBoxRow": "PlotDetailCard-module__iScONa__yearBoxRow",
  "yearLabel": "PlotDetailCard-module__iScONa__yearLabel",
  "yearLabelHighlight": "PlotDetailCard-module__iScONa__yearLabelHighlight",
  "yearSection": "PlotDetailCard-module__iScONa__yearSection",
  "yearSectionWithNotes": "PlotDetailCard-module__iScONa__yearSectionWithNotes",
});
